let url = new Object()
const name = `dealers`

const common = `/api/${name}/`
url.common = {
}

const adminUrl = `/api/${name}/admin/`
url.admin = {
  getByIdName: `${adminUrl}getbyidname`
}

const dealerUrl = `/api/${name}/dealer/`
url.dealer = {
}

export default url
